import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import CustomButton from "../../../helperComponents/CustomButton";
import { BiCalendar, BiExport, BiUser } from "react-icons/bi";
import { GrDisabledOutline } from "react-icons/gr";
import { TbBeach } from "react-icons/tb";
import { GoIssueOpened } from "react-icons/go";
import { useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine";
import CustomPagination from "../../../helperComponents/CustomPagination";
import CustomMasonry from "../../../helperComponents/CustomMasonry";
import EmployeeCard from "./EmployeeCard";
import LoadingSection from "../../../helperComponents/LoadingSection";
import ListSizeSetter from "../../../helperComponents/ListSizeSetter";
import ListPage from "../../../customUiForCs/ListPage";
import goTo from "../../../../controllers/goTo";
import exportFunction from "../../../../controllers/customControllerForCS/exportFunction";
import DropDownInput from "../../../helperComponents/DropDownInput";
import employeeTypes from "../../../../data/employee/employeeTypes";
import NomenclatureOfEmployee from "../nomenclature/NomenclatureOfEmployee";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--gradientSurface);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

let columns = [
  "Registration Number",
  "Full Name",
  // "Last Name",
  // "First Name",
  "Employee Responsibility",
  "Contract Type",
  "Hiring Date",
  "Contract End Date",
  "Site Place Name",
  "Zone Name",

  //
  // "Nickname",
  // "Site Codename",

  "Day Of Rest",

  "Shift",
  // "Is Active",

  // "Dispute",
  // "Vacation",
];

//without depart date
let employeeListExportColumns = [
  "Registration Number",
  // "First Name",
  // "Last Name",
  "Full Name",
  "Employee Responsibility",
  "Contract Type",
  "Hiring Date",
  "Contract End Date",
  "Date Of Birth",
  "Phone Number",
  "Cnps Number",
  "Base Salary",
  "Prime",
  "Shift",
  "Day Of Rest",
  "Has Badge",
  "Is Insured",
  "Payment Type",
  "Gender",
  "Marriage Status",
  "Number Of Children",
  "Site Place Name",
  "Zone Name",
  "Site Client Name",
  "Comments",
];

//has depart date
let inactiveEmployeeListExportColumns = [
  "Registration Number",
  // "First Name",
  // "Last Name",
  "Full Name",
  "Employee Responsibility",
  "Contract Type",
  "Hiring Date",
  "Contract End Date",
  "Date Of Birth",
  "Phone Number",
  "Cnps Number",
  "Base Salary",
  "Prime",
  "Shift",
  "Day Of Rest",
  "Has Badge",
  "Is Insured",
  "Payment Type",
  "Depart Date",
  "Gender",
  "Marriage Status",
  "Number Of Children",
  "Site Place Name",
  "Zone Name",
  "Site Client Name",
  "Comments",
];

let absenceListExportColumns = [
  "Profile Registration Number",
  "Profile First Name",
  "Profile Last Name",
  "Start Date",
  "End Date",
  "Is Justified",
  "Note",
  "Site Place Name",
  "Zone Name",
];
let disputeListExportColumns = [
  "Profile Registration Number",
  "Profile First Name",
  "Profile Last Name",
  "Date",
  "Response",
  "Reason",
  "Suspension Days",
];
let vacationListExportColumns = [
  "Profile Registration Number",
  "Profile First Name",
  "Profile Last Name",
  "Start Date",
  "End Date",
  "Note",
];

export default function EmployeeListPage() {
  const [accountType, setAccountType] = useState("EMPLOYEE");

  return (
    <LoggedInBoilerplate titleLine1={"Liste des"} titleLine2={"Employés"}>
      <NomenclatureOfEmployee
        tableViewSettings={{ columns }}
        columns={2}
        buttons={[
          {
            icon: <BiUser />,
            text: "Ajouter un agent",
            onClick: goTo("/add-employee"),
          },
          {
            icon: <BiExport />,
            text: "Exporter",
            permissionName: "employeeExportPermissions",
            onClick: exportFunction({
              title: "Exporter",
              path: "/employees/?forExport=true&accountType=EMPLOYEE&isActive=TRUE",
              selectedFields: employeeListExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <BiCalendar />,
            text: "Exporter Absences",
            permissionName: "employeeExportAbsencePermissions",
            onClick: exportFunction({
              title: "Exporter Absences",
              path: "/absences/?forExport=true",
              selectedFields: absenceListExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <GoIssueOpened />,
            text: "Exporter Contentieux",
            permissionName: "employeeExportDisputePermissions",
            onClick: exportFunction({
              title: "Exporter Contentieux",
              path: "/disputes/?forExport=true",
              selectedFields: disputeListExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <TbBeach />,
            text: "Exporter Congés",
            permissionName: "employeeExportVacationPermissions",
            onClick: exportFunction({
              title: "Exporter Congés",
              path: "/vacations/?forExport=true",
              selectedFields: vacationListExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <GrDisabledOutline />,
            text: "Exporter Personnels Inactifs",
            permissionName: "employeeExportInactivePermissions",
            onClick: exportFunction({
              title: "Exporter Personnels Inactifs",
              path: "/employees/?forExport=true&isActive=FALSE&accountType=EMPLOYEE",
              selectedFields: inactiveEmployeeListExportColumns,
              autoDownloadExcel: true,
            }),
          },
        ]}
      />
    </LoggedInBoilerplate>
  );
}
